export const NAME = 'chat'